import { Controller } from "stimulus"
import validate from "validate.js"

const CLASS_NOT_VALID = 'is-not-valid';
const CLASS_HAS_VALUE = 'has-value';
const CLASS_IS_FOCUSED = 'is-focused';
const CLASS_MSG_ACTIVE = 'is-msg-active';

export default class extends Controller {
    static targets = [ 'inputItem', 'checkItem', 'textItem', 'msg', 'msgWrap'];
    inputItems = [];
    checkItems = [];
    textItems = [];
    url = "";

    initialize() {
        this.submit = this.submit.bind(this);
        this.sendSuccess = this.sendSuccess.bind(this);
        this.sendError = this.sendError.bind(this);
    }

    connect() {
        this.url = this.element.getAttribute('action');
        this.element.addEventListener('submit', this.submit);

        this.inputItemTargets.forEach((itemTarget) => {
            const input = itemTarget.querySelector('input');
            const required = input.getAttribute('required');
            const type = input.getAttribute('data-type');
            const item = {
                self: itemTarget,
                input: input,
                required: required,
                type: type,
                valid: true,
            };

            this.inputItems.push(item);

            input.addEventListener('focus', (e) => {
                itemTarget.classList.add(CLASS_IS_FOCUSED);
            });

            input.addEventListener('blur', (e) => {
                itemTarget.classList.remove(CLASS_IS_FOCUSED);

                if (item.input.value !== '') {
                    itemTarget.classList.add(CLASS_HAS_VALUE);
                    this.validateValue(item);
                } else {
                    itemTarget.classList.remove(CLASS_HAS_VALUE);
                }
            });

            input.addEventListener('input', (e) => {
                if (!item.valid) {
                    // console.log('not valid');
                    this.validateValue(item);
                }
            });
        });

        this.checkItemTargets.forEach((item) => {
            const input = item.querySelector('input');

            this.checkItems.push({
                self: item,
                input: input,
            });
        });

        this.textItemTargets.forEach((item) => {
            const textarea = item.querySelector('textarea');

            this.textItems.push({
                self: item,
                textarea: textarea,
            });
        });

    }

    submit(e) {
        e.preventDefault();
        this.msgTarget.classList.add(CLASS_MSG_ACTIVE);

        if(!this.validateAll()) {
            this.msgWrapTarget.innerHTML = "<p>Please fix errors above</p>";
            return;
        } else {
            this.sendData();
        }
    }

    sendData() {

        const data = new FormData(this.element);

        fetch(this.url, {
            method: 'post',
            body: data,
            headers: {
                'Accept' : 'application/json',
                'x-requested-with' : 'XMLHttpRequest'
            }
        })
        .then((response) => {
            this.sendSuccess();
            console.log('response', response);
        });
    }

    sendSuccess() {
        this.clearAll();
        console.log('sendSuccess', this.msgWrapTarget);
        this.msgWrapTarget.innerHTML = `<p><strong>Thank you for your message.</strong><br/>We will get back to as soon as possible.</p><a href="/">Return to Home</a>`;
    }

    sendError() {

    }

    clearAll() {
        this.inputItems.forEach((item) => {
            item.input.value = '';
        });

        this.checkItems.forEach((item) => {
            item.input.checked = false;
        });

        this.textItems.forEach((item) => {
            item.textarea.value = '';
        });
    }

    validateAll() {
        console.log('Validate all', isValid);
        let isValid = true;
        this.inputItems.forEach((item) => {
            let notValid = this.validateValue(item);
            if (notValid) {
                item.self.scrollIntoView();
                isValid = false;
            }
        });

        return isValid;
    }

    validateValue(item) {
        const target = item.self;
        const value = item.input.value;
        const required = item.required;
        const type = item.type;

        // console.log('validateValue');
        let constraints = { 'field' : {}};

        if (required !== null) {
            constraints.field.presence = { allowEmpty: false };
        }

        if (type === 'email') {
            constraints.field.email = true;
        }

        let notValid = validate({field: value}, constraints);

        if (notValid) {
            item.valid = false;
            target.classList.add(CLASS_NOT_VALID);
        } else {
            item.valid = true;
            target.classList.remove(CLASS_NOT_VALID);
        }

        // console.log(notValid);
        return notValid;
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/contact-form_controller.js